import { SVGProps } from '@components/Icon/types';

export const Menu = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3, 5)">
      <path
        d="M17.1444 12.1732C17.6486 12.1732 18.0577 12.5824 18.0577 13.0866C18.0577 13.5908 17.6486 14 17.1444 14H0.913388C0.409165 14 1.3392e-05 13.5908 0 13.0866C0 12.5824 0.409157 12.1732 0.913388 12.1732H17.1444Z"
        fill={fill}
      />
      <path
        d="M17.1444 6.08661C17.6486 6.08661 18.0577 6.49577 18.0577 7C18.0577 7.50422 17.6486 7.91339 17.1444 7.91339H0.913388C0.409165 7.91339 1.3392e-05 7.50422 0 7C0 6.49577 0.409157 6.08661 0.913388 6.08661H17.1444Z"
        fill={fill}
      />
      <path
        d="M17.1444 0C17.6486 1.04527e-06 18.0577 0.409157 18.0577 0.913388C18.0577 1.41761 17.6486 1.82678 17.1444 1.82678H0.913388C0.409165 1.82678 1.3392e-05 1.41761 0 0.913388C0 0.409157 0.409157 0 0.913388 0H17.1444Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'menu';
